import { useContext, useCallback } from 'react';
import { formatListData, AjaxContext } from 'commons-ui';
import { GAME_KEY_MAP } from 'pages/admin/zooKeeper/utils/helper';
import { IrowData } from 'pages/admin/zooKeeper/utils/zk.interface';
import { ROUTE_ENDPOINTS } from '../types';

const useService = () => {
	const { getData, postData } = useContext(AjaxContext);
	const getZkChangeHistory = useCallback(async ({ app }: { app: { appName: string } }) => {
		const response = await getData({
			endpoint: ROUTE_ENDPOINTS.GET_ZK_CHANGE_HISTORY,
			queryParams: {
				game: GAME_KEY_MAP[app.appName],
				appName: app.appName
			}
		});
		const listData = formatListData(response?.data?.data).map((item: IrowData) => ({
			...item,
			hideAction: item.canRevert
		}));

		return {
			rowCount: listData.length,
			data: listData
		};
	}, []);

	const requestRevertZkChange = useCallback((appName: string, data: IrowData) => {
		return postData({
			endpoint: ROUTE_ENDPOINTS.REVERT_ZK_CONFIG,
			body: { configId: data._id, game: GAME_KEY_MAP[appName], appName },
			queryParams: { appName }
		});
	}, []);

	return {
		getZkChangeHistory,
		requestRevertZkChange
	};
};

export default useService;
